module.exports = __webpack_public_path__ + "static/media/cm.c972441e.svg";